import axiosInstance from "./AxiosInstance";
import config from "../config";

export const createNote = (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.createNote,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
export const createProgressNote = (data) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.createProgressNote,
    method: "post",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: data,
  });
};
